const ReapInActiveIcon = () => {
  return (
    <svg width='16' height='22' viewBox='0 0 16 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.0552 22.0098H6.8286L0.496094 12.5863L1.16905 11.4689H7.06076L7.9115 9.90712L5.19409 5.99504L5.89236 4.85345H10.5143L11.0476 3.77415L9.18106 1.12034L9.86673 -0.00976562H13.13L15.505 3.45495L14.8061 4.66536H11.945L11.3091 5.99504L13.9094 9.8388L13.2747 10.938H8.70742L8.38944 11.6608L14.7201 20.7956L14.0552 22.0098Z'
        fill='#5E626E'
      />
    </svg>
  );
};

export default ReapInActiveIcon;
